export default __webpack_public_path__ + "static/media/liked.7933702b.svg";